import { BUILDER_PUBLIC_API_KEY } from "../../config/apiKeys.js";

const SERVICE_PAGE_MODEL = "service-page";
const BUILDER_CONTENT_API_URL = `https://cdn.builder.io/api/v3/content/${SERVICE_PAGE_MODEL}`;
const BUILDER_CONTENT_PAGE_SIZE = 100;

/**
 * @returns {Promise<import("@builder.io/sdk-svelte").BuilderContent[]>}
 */
export async function fetchAllServicePageEntries() {
    /** @type {import("@builder.io/sdk-svelte").BuilderContent[]} */
    const entries = [];
    let offset = 0;
    let hasMore = true;

    while (hasMore) {
        const params = new URLSearchParams({
            apiKey: BUILDER_PUBLIC_API_KEY,
            limit: String(BUILDER_CONTENT_PAGE_SIZE),
            offset: String(offset),
            cachebust: "true",
        });
        const response = await fetch(`${BUILDER_CONTENT_API_URL}?${params.toString()}`);

        if (!response.ok) {
            throw new Error(
                `Builder service-page fetch failed: ${response.status} ${response.statusText}`,
            );
        }

        const body = await response.json();
        /** @type {import("@builder.io/sdk-svelte").BuilderContent[]} */
        const results = Array.isArray(body?.results) ? body.results : [];

        entries.push(...results);
        offset += results.length;
        hasMore = results.length === BUILDER_CONTENT_PAGE_SIZE;
    }

    return entries;
}
